import { type CanvasAssetPayload } from './canvasAssetDropTypes';

function isCanvasAssetPayload(x: unknown): x is CanvasAssetPayload {
  if (typeof x !== 'object' || x === null) return false;
  const idVal = Object.getOwnPropertyDescriptor(x, 'id')?.value;
  return typeof idVal === 'string';
}

/**
 * Parses raw dataTransfer payload into an array of asset payloads.
 * Handles both single object and array JSON. Validates shape; invalid entries are omitted.
 */
export function parseCanvasAssetPayload(rawPayload: string): CanvasAssetPayload[] {
  const parsed: unknown = JSON.parse(rawPayload);
  if (Array.isArray(parsed)) {
    return parsed.filter((item): item is CanvasAssetPayload => isCanvasAssetPayload(item));
  }
  if (isCanvasAssetPayload(parsed)) {
    return [parsed];
  }
  return [];
}
